import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import InventoryGrid from "./cases/InventoryGrid";

export default function InventoryModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#19142A] dark:bg-[#141021] border border-[#2A2440] dark:border-[#2A2440] rounded-lg max-w-3xl max-h-[85vh] overflow-y-auto text-white dark:text-white">
        <DialogHeader><DialogTitle className="font-cases uppercase">Your Inventory</DialogTitle></DialogHeader>
        {open && <InventoryGrid />}
      </DialogContent>
    </Dialog>
  );
}
